module.exports = __webpack_public_path__ + "static/media/3032.f111213c.jpg";